module.exports = __webpack_public_path__ + "static/media/circle-blue-check.edd8979e.svg";